import { formatVolume } from "utils";

export const promoSummaryMapper = ({ val, shiftId }) => {
  const isPumpDiscount = val?.type === "Pump Discount";
  const isFuel = val.transactionType === "fuel";
  const promoName = isPumpDiscount ? "Pump Discount" : val?.discount;

  const volume = isPumpDiscount
    ? formatVolume(val.totalQuantities ?? 0)
    : isFuel
      ? formatVolume(val.totalLiters ?? 0)
      : "--";
  const quantity = !isFuel && val.totalQuantities > 0 ? val.totalQuantities : "--";
  const totalTransactions =
    val?.totalTransactions > 0 ? val.totalTransactions : val?.transactions?.length;

  return {
    promoName: promoName,
    transactionCount: totalTransactions,
    volume: volume,
    qty: quantity,
    // actions: (
    //   <Link
    //     target="_blank"
    //     rel="noopener noreferrer"
    //     to={`/bir-report/discount-report?shiftId=${shiftId}&promoName=${promoName}`}
    //     style={{
    //       textDecoration: "none",
    //     }}
    //   >
    //     <div
    //       style={{
    //         color: "#5349b7",
    //         fontWeight: "500",
    //         display: "flex",
    //         justifyContent: "center",
    //         alignContent: "center",
    //         alignItems: "center",
    //       }}
    //     >
    //       <span>View</span>
    //       <NavigateNextIcon fontSize="small" />
    //     </div>
    //   </Link>
    // ),
  };
};
